import gql from 'graphql-tag';

export const GET_CMS_PAGE = gql`
  query CmsPage($id: String!) {
    cms {
      page(id: $id) {
        documentTitle
        metaTags {
          name
          content
        }
        breadcrumbs {
          name
          url
        }
        htmlContent
        source
      }
    }
  }
`;
